import React from 'react';
import './Footer.css';

const BdFooter = () => {
  return (
    <div className="bd">
      <footer>
        <p className="footer-text">
          © 2024 Ligaincom. All rights reserved.
        </p>
        <small className="float-end me-1">
          Diseño y desarrollo por Alejandro Travé{' '}
          <a href="mailto:atravep@gmail.com">atravep@gmail.com</a>
        </small>
      </footer>
    </div>
  );
};

export default BdFooter;

